import { render, staticRenderFns } from "./TrailerDetails.vue?vue&type=template&id=11985420&scoped=true"
import script from "./TrailerDetails.vue?vue&type=script&lang=js"
export * from "./TrailerDetails.vue?vue&type=script&lang=js"
import style0 from "./TrailerDetails.vue?vue&type=style&index=0&id=11985420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11985420",
  null
  
)

export default component.exports